import React from 'react';
import { find } from 'lodash';

import { TemplateComponent } from 'components';
import { withRedux } from 'helpers';

import * as styles from './titleText.styles';

class TitleText extends React.Component {
  setTemplate = templateId => () => {
    const { activeApp } = this.props;
    this.props.actions.setTemplate(activeApp.id, templateId);
  };

  render() {
    const { activeTemplate } = this.props;

    const title = find(activeTemplate.components, { componentNumber: 1 });
    const content = find(activeTemplate.components, { componentNumber: 2});

    return (
      <div className={styles.container}>
        <TemplateComponent {...title} setTemplate={this.setTemplate} />

        <div className={styles.content}>
          <TemplateComponent {...content} setTemplate={this.setTemplate}/>
        </div>
      </div>
    );
  }
}

export default withRedux(TitleText);
